import { render, staticRenderFns } from "./CookieModal.vue?vue&type=template&id=25611739&scoped=true&"
import script from "./CookieModal.vue?vue&type=script&lang=js&"
export * from "./CookieModal.vue?vue&type=script&lang=js&"
import style0 from "./CookieModal.vue?vue&type=style&index=0&id=25611739&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25611739",
  null
  
)

export default component.exports